import PortalIdParser from 'PortalIdParser';
import formatName from 'I18n/utils/formatName';
import { DealPlanBuyerTypename, DealPlanCompanyAssigneeTypename, DealPlanSellerTypename, SellerOwnerTypename, BuyerOwnerTypename, CompanyOwnerTypename } from '../../__generated__/chirp/com/hubspot/deal/plans/rpc/DealPlansRpc';
export function assigneeToOwner(assignee) {
  switch (assignee.__typename) {
    case DealPlanSellerTypename:
      return {
        ownerId: assignee.userId,
        __typename: SellerOwnerTypename
      };
    case DealPlanCompanyAssigneeTypename:
      return {
        companyId: assignee.companyId,
        __typename: CompanyOwnerTypename
      };
    case DealPlanBuyerTypename:
      return {
        contactVid: assignee.contactVid,
        __typename: BuyerOwnerTypename
      };
    default:
      {
        const _exhaustive = assignee;
        throw new Error(`Unknown assignee type: ${_exhaustive.__typename}`);
      }
  }
}
export function formatContactDisplayName({
  firstName,
  lastName,
  email
}) {
  if (firstName || lastName) {
    return formatName({
      firstName: firstName !== null && firstName !== void 0 ? firstName : '',
      lastName: lastName !== null && lastName !== void 0 ? lastName : ''
    });
  }
  return email !== null && email !== void 0 ? email : '';
}
export function getMilestoneAssigneeName(assignee) {
  switch (assignee === null || assignee === void 0 ? void 0 : assignee.__typename) {
    case DealPlanBuyerTypename:
    case DealPlanSellerTypename:
      return formatContactDisplayName(assignee);
    case DealPlanCompanyAssigneeTypename:
      return assignee.name;
    default:
      return;
  }
}
export function getContactHref(assignee) {
  switch (assignee === null || assignee === void 0 ? void 0 : assignee.__typename) {
    case DealPlanBuyerTypename:
      return `/contacts/${PortalIdParser.get()}/contact/${assignee.contactVid}`;
    case DealPlanCompanyAssigneeTypename:
      return `/contacts/${PortalIdParser.get()}/record/0-2/${assignee.companyId}`;
    default:
      return null;
  }
}